import React from "react";
import { cn } from "../../lib/utils";

export default function Card({ title, children, actions, className = "", ...props }) {
  return (
    <section
      className={cn(
        "min-w-0 rounded-xl border border-border bg-card text-card-foreground shadow-sm dark:bg-card/95 dark:backdrop-blur-sm",
        className
      )}
      {...props}
    >
      {title && (
        <header className="flex flex-col gap-3 border-b border-border px-4 py-3 sm:flex-row sm:items-center sm:justify-between sm:px-6">
          <h3 className="font-display text-lg font-semibold">{title}</h3>
          {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
        </header>
      )}
      <div className="p-4 sm:p-6">{children}</div>
    </section>
  );
}

export function CardHeader({ className = "", ...props }) {
  return <div className={cn("flex flex-col space-y-1.5 p-6", className)} {...props} />;
}

export function CardTitle({ className = "", ...props }) {
  return <h3 className={cn("font-display text-lg font-semibold leading-none tracking-tight", className)} {...props} />;
}

export function CardDescription({ className = "", ...props }) {
  return <p className={cn("text-sm text-muted-foreground", className)} {...props} />;
}

export function CardContent({ className = "", ...props }) {
  return <div className={cn("p-6 pt-0", className)} {...props} />;
}

export function CardFooter({ className = "", ...props }) {
  return <div className={cn("flex items-center p-6 pt-0", className)} {...props} />;
}
